var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8972 17.168C13.8012 17.168 15.2852 15.838 15.2852 13.934C15.2852 12.282 14.1652 11.008 12.4992 10.882L14.6972 8.656V7.2H9.32119V8.796H12.5972L10.6372 10.854V12.072L11.8972 12.17C12.8912 12.24 13.5772 12.954 13.5772 13.864C13.5772 14.872 12.8352 15.558 11.9252 15.558C11.0712 15.558 10.4552 14.998 10.2732 14.214L8.71919 14.704C9.06919 16.174 10.1612 17.168 11.8972 17.168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge3);
export default __webpack_public_path__ + "static/media/Badge 3.73eebcfa219242531d98cfc51ed4b4df.svg";
export { ForwardRef as ReactComponent };